<script>
import StatusComponent from '@/components/widgets/badges/status';
import Multiselect from 'vue-multiselect';

export default {
  components: {
    StatusComponent,
    Multiselect,
  },
  props: {
    list: { type: Array, default: () => [] },
    defaultSelectedList: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectedList: this.defaultSelectedList,
    };
  },
  methods: {
    listChanged() {
      this.$emit('selection-change', this.selectedList);
    },
  },
  watch: {
    defaultSelectedList(newValue) {
      this.selectedList = newValue;
    },
  },
};
</script>

<template>
  <multiselect
    id="statusSelect"
    ref="multiselectStatus"
    v-model="selectedList"
    :options="list"
    :label="'statusName'"
    track-by="statusCode"
    :placeholder="$t('general.pickAValue')"
    :multiple="true"
    :show-labels="false"
    :hide-selected="true"
    :close-on-select="false"
    :clear-on-select="false"
    :searchable="false"
    @input="listChanged"
  >
    <template v-slot:noOptions>
      {{ $t('general.noResult') }}
    </template>
    <template slot="option" slot-scope="{ option }">
      <div class="option__desc">
        <StatusComponent
          :text="option.statusName"
          :variant="option.statusVariant"
        />
      </div>
    </template>
    <template slot="tag" slot-scope="{ option, remove }">
      <span
        class="custom__tag"
        style="margin-right: 5px; cursor: pointer"
        @mousedown.prevent="remove(option)"
      >
        <StatusComponent
          :text="option.statusName"
          :variant="option.statusVariant"
          :withX="true"
        />
      </span>
    </template>
  </multiselect>
</template>